import { Group, Input, Select } from "@mantine/core";
import { useFlowStore } from "../../../../../../../stores/WorkflowStore";
import { useLanguage } from "../../../../../../../stores/LanguageStore";
import {
  dayOptions,
  getDelay,
  getTimeOptions,
  hourOptions,
  minuteOptions,
  monthOptions,
} from "./events";
import { useCallback, useEffect, useMemo, useState } from "react";

const DelaySelector = ({ id, when_minutes, event_type }) => {
  const updateNodeData = useFlowStore((s) => s.updateNodeData);
  const [timeType, setTimeType] = useState(getDelay(when_minutes).type);
  const [timeValue, setTimeValue] = useState(getDelay(when_minutes).value);
  const lang = useLanguage((s) => s.language);

  const handleTimeChange = useCallback(
    (type, value) => {
      let newWhenMinutes = 0;
      if (type === "0") {
        setTimeValue(value || monthOptions[0]);
        newWhenMinutes = parseInt(value.split(" ")[0]) * 30 * 24 * 60;
      } else if (type === "1") {
        setTimeValue(value || dayOptions[0]);
        newWhenMinutes = parseInt(value.split(" ")[0]) * 24 * 60;
      } else if (type === "2") {
        setTimeValue(value || hourOptions[0]);
        newWhenMinutes = parseInt(value.split(" ")[0]) * 60;
      } else if (type === "3") {
        setTimeValue(value || minuteOptions[0]);
        newWhenMinutes = parseInt(value.split(" ")[0]);
      }

      updateNodeData(id, { when_minutes: newWhenMinutes });
    },
    [id, updateNodeData]
  );

  const handleDelayTypeChange = useCallback(
    (newType) => {
      setTimeType(newType);
      if (newType === "0") handleTimeChange(newType, monthOptions()[0]);
      if (newType === "1") handleTimeChange(newType, dayOptions()[0]);
      else if (newType === "2") handleTimeChange(newType, hourOptions()[0]);
      else if (newType === "3") handleTimeChange(newType, minuteOptions()[0]);
    },
    [handleTimeChange]
  );

  const timeValueOptions = useMemo(() => {
    if (timeType === "0") {
      return monthOptions();
    }
    if (timeType === "1") {
      return dayOptions();
    }
    if (timeType === "2") {
      return hourOptions();
    }
    if (timeType === "3") {
      return minuteOptions();
    }
  }, [timeType]);

  useEffect(() => {
    if (timeType !== "1" && event_type === "not_active") {
      handleDelayTypeChange("1");
    }
  }, [event_type, handleDelayTypeChange, timeType]);

  useEffect(() => {    
    if (event_type === "split_contacts" && !when_minutes) {
      setTimeType("3");
      handleTimeChange("3", minuteOptions()[0]);
    }
  }, [event_type, handleTimeChange, when_minutes]);

  return (
    <>
      <Input.Label size="xs" mt={8}>
        {lang.workflows.nodes.events.delay.name}
      </Input.Label>
      <Group wrap="nowrap" gap={4}>
        <Select
          value={getDelay(when_minutes).type}
          onChange={handleDelayTypeChange}
          size="xs"
          data={getTimeOptions(event_type)}
          w={timeType !== "4" ? 110 : "100%"}
          variant="default"
          comboboxProps={{
            size: "sm",
            width: 140,
          }}
          searchable
        />
        <Select
          value={timeValue}
          onChange={(v) => {
            setTimeValue(v);
            handleTimeChange(timeType, v);
          }}
          size="xs"
          required
          variant="default"
          data={timeValueOptions}
          w={135}
          comboboxProps={{
            size: "sm",
          }}
          searchable
        />
      </Group>
    </>
  );
};

export default DelaySelector;
